// extracted by mini-css-extract-plugin
module.exports = {"media":"mediaDestacat_media__hwglo","imatge":"mediaDestacat_imatge__sn0Jl","peuFoto":"mediaDestacat_peuFoto__oIY1r","audio":"mediaDestacat_audio__ghm_x"};